import React, { useState } from 'react'
import { loggedInSelector } from 'spa/selectors/users'
import { FormattedMessage } from 'react-intl'
import { AVAILABLE_FEATURES, isFeatureEnabled } from 'spa/selectors/features'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Heading } from 'spa/components/typography'
import { Logo } from 'spa/components/logo'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { injectIntl } from 'react-intl'
import classNames from 'classnames'
import styles from './styles'

function PreSunsetModal({ intl }) {
  const isLoggedIn = useSelector(loggedInSelector)
  const sunsetFeatureStatus = useSelector(state =>
    isFeatureEnabled(state.features, AVAILABLE_FEATURES.SUNSET_MODE)
  )
  const sunsetModeStatus = useSelector(state => state.sunset.sunsetModeStatus)
  const preSunsetModeStatus = useSelector(
    state => state.sunset.preSunsetModeStatus
  )
  const isSunsetOn = isLoggedIn ? sunsetFeatureStatus : sunsetModeStatus
  const isPreSunsetOn = !isSunsetOn && preSunsetModeStatus

  const [isOpen, setIsOpen] = useState(sessionStorage.getItem('preSunsetViewed') !== 'true')

  const onClose = () => {
    setIsOpen(false)
    sessionStorage.setItem('preSunsetViewed', 'true')
  }

  return isPreSunsetOn ? (
    <Modal className={styles.presunsetModal} isOpen={isOpen}>
      <FontAwesomeIcon
        className={styles.closeButton}
        icon={['fal', 'times-circle']}
        onClick={onClose}
      />
      <div className={styles.header}>
        <Logo forceDarkMode />
        <div
          className={classNames(
            styles.headingContainer,
            styles.presunsetContainer
          )}
        >
          <Heading className={styles.heading}>
            <FormattedMessage
              id="djcity.common.presunset.title"
              defaultMessage="We’re joining Beatport on 12/31/26"
            />
          </Heading>
          <div className={styles.section1}>
            <FormattedMessage
              id="djcity.common.presunset.subtitle"
              defaultMessage="You won’t have access to DJcity after this date. New DJcity signups are currently closed."
            />
          </div>
          <a
            className={styles.learnMoreLink}
            target="_blank"
            href={intl.formatMessage({
              id: 'djcity.common.presunset.learnmore.link',
              defaultMessage: '/',
            })}
          >
            <FormattedMessage
              id="djcity.common.presunset.learnmore"
              defaultMessage="Learn more"
            />
          </a>
        </div>
      </div>
    </Modal>
  ) : null
}

PreSunsetModal.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(PreSunsetModal)
